export default __webpack_public_path__ + "locales/lv/Ldap.json?hash=4be24d4c625de2e6cb93ba8a5ce7d9c3";